/* Deiyaa wholesale: client-side Certificate of Resale (CRT-61) generator.
   Draws a signature (signature_pad) and builds a completed PDF (pdf-lib) in the
   browser, for the buyer's own records. Nothing is uploaded; the application
   form itself is what sends the certificate to the bakery. Libraries load from
   CDN only when the resale section is used. */
(function () {
  var form = document.getElementById('WholesaleApplication');
  if (!form) return;
  var pad = document.getElementById('wa-sign-pad');
  var clearBtn = document.getElementById('wa-sign-clear');
  var dlBtn = document.getElementById('wa-download-crt61');
  var exemption = document.getElementById('wa-exemption');
  if (!dlBtn || !pad) return;

  var sigPad = null;
  var libsPromise = null;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = function () {
        reject(new Error('Could not load ' + src));
      };
      document.head.appendChild(s);
    });
  }

  function ensureLibs() {
    if (libsPromise) return libsPromise;
    libsPromise = Promise.all([
      window.SignaturePad
        ? Promise.resolve()
        : loadScript('https://cdnjs.cloudflare.com/ajax/libs/signature_pad/4.1.7/signature_pad.umd.min.js'),
      window.PDFLib
        ? Promise.resolve()
        : loadScript('https://cdnjs.cloudflare.com/ajax/libs/pdf-lib/1.17.1/pdf-lib.min.js'),
    ]);
    return libsPromise;
  }

  function sizePad() {
    var rect = pad.getBoundingClientRect();
    if (!rect.width) return;
    var ratio = Math.max(window.devicePixelRatio || 1, 1);
    pad.width = rect.width * ratio;
    pad.height = rect.height * ratio;
    pad.getContext('2d').scale(ratio, ratio);
    if (sigPad) sigPad.clear();
  }

  function initPad() {
    if (!window.SignaturePad) return;
    if (!sigPad) {
      sigPad = new window.SignaturePad(pad, { penColor: '#1d2016', backgroundColor: 'rgba(0,0,0,0)' });
    }
    sizePad();
  }

  if (exemption) {
    exemption.addEventListener('change', function () {
      if (exemption.checked) ensureLibs().then(initPad);
    });
    if (exemption.checked) ensureLibs().then(initPad);
  }
  if (clearBtn)
    clearBtn.addEventListener('click', function () {
      if (sigPad) sigPad.clear();
    });
  window.addEventListener('resize', function () {
    if (sigPad && sigPad.isEmpty()) sizePad();
  });

  function val(name) {
    var checked = form.querySelector('[name="' + name + '"]:checked');
    if (checked) return (checked.value || '').trim();
    var el = form.querySelector('[name="' + name + '"]');
    return el ? (el.value || '').trim() : '';
  }

  function requireFields(fields) {
    for (var i = 0; i < fields.length; i++) {
      if (!val(fields[i].name)) {
        var el = form.querySelector('[name="' + fields[i].name + '"]');
        if (el && el.focus) el.focus();
        alert('Please complete "' + fields[i].label + '" before downloading the certificate.');
        return false;
      }
    }
    return true;
  }

  function wrap(str, font, size, maxW) {
    var words = str.split(' ');
    var lines = [];
    var cur = '';
    for (var i = 0; i < words.length; i++) {
      var test = cur ? cur + ' ' + words[i] : words[i];
      if (font.widthOfTextAtSize(test, size) > maxW && cur) {
        lines.push(cur);
        cur = words[i];
      } else cur = test;
    }
    if (cur) lines.push(cur);
    return lines;
  }

  dlBtn.addEventListener('click', function () {
    var need = [
      { name: 'contact[Business name]', label: 'Business name' },
      { name: 'contact[Business address]', label: 'Business address' },
      { name: 'contact[name]', label: 'Your name' },
      { name: 'contact[Resale registration]', label: 'Resale registration' },
      { name: 'contact[Certificate type]', label: 'Certificate type' },
      { name: 'contact[Electronic signature, full legal name]', label: 'Full legal name' },
      { name: 'contact[Signature date]', label: 'Date' },
    ];
    if (!requireFields(need)) return;
    var original = dlBtn.textContent;
    dlBtn.disabled = true;
    dlBtn.textContent = 'Preparing PDF…';
    ensureLibs()
      .then(buildPdf)
      .then(function () {
        dlBtn.disabled = false;
        dlBtn.textContent = original;
      })
      .catch(function (e) {
        dlBtn.disabled = false;
        dlBtn.textContent = original;
        alert('Sorry, the certificate could not be generated. ' + (e && e.message ? e.message : ''));
      });
  });

  function buildPdf() {
    var P = window.PDFLib;
    var doc, font, bold;
    return P.PDFDocument.create()
      .then(function (d) {
        doc = d;
        return doc.embedFont(P.StandardFonts.Helvetica);
      })
      .then(function (f) {
        font = f;
        return doc.embedFont(P.StandardFonts.HelveticaBold);
      })
      .then(function (b) {
        bold = b;
        var page = doc.addPage([612, 792]);
        var M = 56;
        var y = 792 - M;
        var dark = P.rgb(0.11, 0.13, 0.1);
        var muted = P.rgb(0.36, 0.39, 0.35);
        var rule = P.rgb(0.8, 0.8, 0.78);

        function text(s, x, yy, size, f, color) {
          page.drawText(s || '', { x: x, y: yy, size: size || 10, font: f || font, color: color || dark });
        }
        function line(yy) {
          page.drawLine({ start: { x: M, y: yy }, end: { x: 612 - M, y: yy }, thickness: 0.75, color: rule });
        }
        function field(lbl, value, x, yy) {
          text(lbl.toUpperCase(), x, yy, 7.5, bold, muted);
          text(value || '—', x, yy - 14, 11, font, dark);
        }

        text('Deiyaa Bakery', M, y, 15, bold);
        text('Certificate of Resale (CRT-61)', M, y - 18, 11, font, muted);
        y -= 42;
        line(y);
        y -= 24;

        field('Seller', 'Deiyaa Bakery', M, y);
        field('Date', val('contact[Signature date]'), 612 - M - 160, y);
        y -= 40;
        field('Purchaser business', val('contact[Business name]'), M, y);
        y -= 38;
        field('Business address', val('contact[Business address]'), M, y);
        y -= 38;
        field('Contact name', val('contact[name]'), M, y);
        field('Title', val('contact[Your title]') || val('contact[Role]'), 612 - M - 240, y);
        y -= 38;
        field('Email', val('contact[email]'), M, y);
        field('Phone', val('contact[phone]'), 612 - M - 240, y);
        y -= 44;
        line(y);
        y -= 24;

        var reg = val('contact[Resale registration]');
        field('Resale registration', reg, M, y);
        y -= 38;
        if (reg.indexOf('Illinois') !== -1 || reg.indexOf('IDOR') !== -1) {
          field('Illinois (IDOR) account ID', val('contact[IDOR account ID]'), M, y);
        } else {
          field('State and registration number', val('contact[Other state and registration number]'), M, y);
        }
        y -= 38;
        field('Certificate type', val('contact[Certificate type]'), M, y);
        y -= 38;
        var prod = val('contact[Products purchased for resale]');
        if (prod) {
          field('Products purchased for resale', prod, M, y);
          y -= 38;
        }
        y -= 6;
        line(y);
        y -= 22;

        var attest =
          'The purchaser certifies they are the identified purchaser and that the purchases described above are made for resale. The signature below is adopted as an electronic signature on this Certificate of Resale.';
        wrap(attest, font, 9.5, 612 - 2 * M).forEach(function (ln) {
          text(ln, M, y, 9.5, font, muted);
          y -= 13;
        });
        y -= 22;

        text('SIGNATURE', M, y, 7.5, bold, muted);
        var sigBaseline = y - 56;

        function finish() {
          page.drawLine({
            start: { x: M, y: sigBaseline },
            end: { x: M + 240, y: sigBaseline },
            thickness: 0.75,
            color: P.rgb(0.6, 0.6, 0.58),
          });
          text(
            'Printed name: ' + val('contact[Electronic signature, full legal name]'),
            M,
            sigBaseline - 16,
            9.5,
            font,
            muted,
          );
          text(
            'Title: ' + (val('contact[Your title]') || val('contact[Role]') || '—'),
            M,
            sigBaseline - 30,
            9.5,
            font,
            muted,
          );
          text('Date: ' + val('contact[Signature date]'), M + 300, sigBaseline - 16, 9.5, font, muted);
          text(
            'Generated from the Deiyaa Bakery wholesale application. Based on Illinois Department of Revenue Form CRT-61.',
            M,
            M - 12,
            7.5,
            font,
            muted,
          );
          return doc.save();
        }

        if (sigPad && !sigPad.isEmpty()) {
          return doc.embedPng(sigPad.toDataURL('image/png')).then(function (png) {
            var scale = Math.min(220 / png.width, 48 / png.height);
            page.drawImage(png, { x: M, y: sigBaseline + 6, width: png.width * scale, height: png.height * scale });
            return finish();
          });
        }
        text(val('contact[Electronic signature, full legal name]'), M, sigBaseline + 10, 18, bold, dark);
        return finish();
      })
      .then(function (bytes) {
        var blob = new Blob([bytes], { type: 'application/pdf' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        var biz = (val('contact[Business name]') || 'certificate').replace(/[^a-z0-9]+/gi, '-').toLowerCase();
        a.href = url;
        a.download = 'deiyaa-crt61-' + biz + '.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(function () {
          URL.revokeObjectURL(url);
        }, 5000);
      });
  }
})();
